import { render } from "./FacturacionComponent.vue?vue&type=template&id=6371b088"
import script from "./FacturacionComponent.vue?vue&type=script&lang=js"
export * from "./FacturacionComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__